import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import uiconfig, {
  ifAllowed,
} from "CommonState/uiconfig";
import {
  popComponent,
} from "CommonCore/location-util";
import {
  DetailEditor,
} from "CommonComponents/detail-view";
import apifetch from "CommonCore/apifetch";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  userSachbErweitert,
  VERWALTUNG_KANZLER,
} from "App/constants";
import {
  setupLookups,
} from "App/shk-form-tab";
import {
  Panel,
} from "CommonComponents/bricks";

@store("user", "k_einrichtungLookup")
@uiconfig
@ifAllowed("page.profil", { redirect: false })
export default class ProfilPage extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
      data: {},
    };
  }

  async refetch() {
    const data = await apifetch(`/api/shknutzer/nutzer`);
    this.setState({ data: data });
  }

  componentDidMount() {
    this.refetch();
  }

  render() {
    const { currentNutzerInflight, user } = this.props;
    const { validationMessage, validationErrors, data } = this.state;

    const schema = {
      displayName: "Profil",
      defaultSort: [{ field: "n_name" }, { field: "n_vorname" }],
      table: [
        {
          field: "n_vorname",
          display: "Vorname",
          maxlength: 100,
        },
        {
          field: "n_name",
          display: "Name",
          maxlength: 100,
        },
        {
          field: "n_email",
          display: "E-Mail",
        },
      ],
    };


    if (data.l_lokal) {
      schema.table.push({ field: "password", display: "Passwort", hint: "nicht geändert", type: "password" });
      schema.table.push({ field: "password_repeat", display: "Bestätigung", type: "password" });
    }

    // Zuständigkeit Einrichtungern
    const einrichtungen = [];

    if (userSachbErweitert(user)) {
      // Zuständigkeit Tarifangestellte
      schema.table.push({ field: "n_zustwiss", display: "Zuständigkeit für wissenschaftliche MA", type: "checkbox" });
      schema.table.push({ field: "n_zusttuv", display: "Zuständigkeit für MA aus Technik und Verwaltung", type: "checkbox" });

      einrichtungen.push({
        field: "einrichtungen_hk",
        display: "Zuständigkeit zu Einrichtungen (HK)",
        lookup: "k_einrichtung.multiselect.e_id.e_bez",
      });
      einrichtungen.push({
        field: "einrichtungen_tarif",
        display: "Zuständigkeit zu Einrichtungen (Tarif)",
        lookup: "k_einrichtung.multiselect.e_id.e_bez",
      });
      einrichtungen.push({
        field: "einrichtungen_lehr",
        display: "Zuständigkeit zu Einrichtungen (Lehr.)",
        lookup: "k_einrichtung.multiselect.e_id.e_bez",
      });
      _.map(einrichtungen, e => schema.table.push(e));
    }

    setupLookups(schema);

    if (userSachbErweitert(user)) {
      _.map(einrichtungen, e => e.choices = lookup => lookup && _.map(_.filter(lookup, e => (e.e_master_eid == e.e_id || e.e_master_eid == VERWALTUNG_KANZLER)
        && !["D", "VE", "ABT"].includes(e.e_typkuerzel)), l => ({ value: l.e_id, label: l.e_kbez })));
    }

    return <div className='detail-form'> <Panel>
      <Breadcrumb name='Profil' path='/profil' />
      <DetailEditor
        modal
        scrollable
        header={<h3>Profil bearbeiten</h3>}
        entity={data}
        schema={schema}
        injects={this.props}
        validationMessage={validationMessage}
        validationErrors={validationErrors}
        onChange={this.onChange}
        inflight={currentNutzerInflight}
        onClose={this.close}
        onSave={this.save}
      />

    </Panel></div>;
  }

  onChange = change => {
    const { data } = this.state;
    _.assign(data, change);
    this.setState({ data });
  };

  close = () => {
    const { history, location } = this.props;
    history.push(popComponent(location));
  };

  save = async() => {
    const { data } = this.state;
    const { user } = this.props;

    this.setState({ validationMessage: null });

    // Validierung falls Passwort geändert werden soll
    if (data.l_lokal && data.password) {
      if (data.password !== data.password_repeat) {
        this.setState({ validationMessage: "Passwort und Bestätigung stimmen nicht überein" });
        return false;
      }
      // Passwortänderung über separate Servicemethode
      const error = await apifetch("/api/shknutzer/nutzer/passwort", {
        method: "PUT",
        body: { l_passwort: data.password },
      });
      if (error) {
        this.setState({ validationMessage: error.um });
        return false;
      }
    }

    await apifetch(`/api/shknutzer/nutzer`, {
      method: "PUT",
      body: data,
    });

    user.name = data.n_name;
    user.vorname = data.n_vorname;
    user.email = data.n_email;
    this.setState({ user });
    this.close();
  };
}
